import React, { Component, ReactNode } from 'react';
import { IReactionDisposer, reaction } from 'mobx';
import _get from 'lodash/get';
import { MOUSE_EVENT_KEY } from '../../../../utils/event/mouse-event/constant';
import { isIpadApp } from '@src/js/service/enterprise/temp-config';
import { RegionType } from '@src/slide/domain/selection/constant/region';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IMobileEditorAppServices } from '@src/slide/application/entry/toc/editor/mobile/mobile-editor-app-service.interface';
import { IMobileRightMenuMananger } from '@src/slide/application/service/mobile-right-menu-manager/core/index.interface';

let MobileRightMenuMananger: IMobileRightMenuMananger | null = null;

export const PopupMenuType = {
    SLIDE: 'slide',
    ELEMENT: 'element',
    NOTE: 'note',
};

interface MobilePopupWrapperProps {
    style?: React.CSSProperties;
    children?: ReactNode;
}

class MobilePopupWrapper extends Component<MobilePopupWrapperProps> {
    private prevMouseDownObjId?: string | null = null;
    private dropEndAndPrevNoMenu = false;
    private container: HTMLElement | null;
    private reaction?: IReactionDisposer;
    private currentSlideIndexReaction?: IReactionDisposer;
    private isDraggingReaction?: IReactionDisposer;
    private selectedArrayReaction?: IReactionDisposer;
    public constructor(props: MobilePopupWrapperProps) {
        super(props);
    }

    public render() {
        const style = {
            ...this.props.style,
            height: '100%',
        };

        return (
            <div id={'PopupWrapper'} style={style}
                ref={(e) => {
                    this.container = e;
                }}
                onContextMenu={this.handleSysContext.bind(this)}
            >
                {this.props.children}
            </div>
        );
    }

    public componentDidMount() {
        document.oncontextmenu = () => false;

        setTimeout(() => {
            if (isIpadApp()) {
                this.container?.addEventListener('touchend', this.imageShowMenu);
                // 这里使用mouseup监听事件的原因：mousedown事件触发先于mouseup
                // 导致getMenuListByType获取的类型为默认值，不触发弹窗
                // 使用mouseup后，mousedown已经选中框，mouseup再次触发获得正确的弹窗
                this.container?.addEventListener('mouseup', this.imageShowMenu);
            }
        }, 200);

        this.reaction = reaction(() => this.getMenuManager()?.hideAllMenuNum, (hideAllMenuNum) => {
            if (hideAllMenuNum) {
                MobileRightMenuMananger?.hideMenu();
            }
        });

        if (isIpadApp()) {
            this.currentSlideIndexReaction = reaction(
                () => this.getSelectionService().currentSlideIndex,
                () => {
                    this.prevMouseDownObjId = null;
                },
            );
            this.isDraggingReaction = reaction(() => this.getEditingStateManager().isDragging, () => {
                if (this.getEditingStateManager().isDragging) {
                    if (this.prevMouseDownObjId === null) {
                        this.dropEndAndPrevNoMenu = true;
                    }
                }
                this.prevMouseDownObjId = null;
            });
            this.selectedArrayReaction = reaction(
                () => this.getSelectArray(),
                () => {
                    MobileRightMenuMananger?.hideMenu();
                    this.prevMouseDownObjId = null;
                },
            );
        }

        this.getMobileRightMenuManager().promise()
            .then((mobileRightMenuMananger) => {
                MobileRightMenuMananger = mobileRightMenuMananger;
            });
    }

    public componentWillUnmount() {
        (isIpadApp()) && this.container && this.container.removeEventListener('mouseup', this.imageShowMenu);
        if (this.reaction) {
            this.reaction();
        }
        if (this.currentSlideIndexReaction) this.currentSlideIndexReaction();
        if (this.isDraggingReaction) this.isDraggingReaction();
        if (this.selectedArrayReaction) this.selectedArrayReaction();
    }

    private getSelectArray() {
        return this.getSelectionService().selectedElements.selectedArray;
    }

    /**
     * 【未选中 -> 选中】类型为shape or table
     * @param ifExistSelectedElement
     * @param selectedType
     * @returns {boolean}
     */
    private selectIsShapeOrTable = (ifExistSelectedElement: boolean, selectedType: string): boolean => (
        !ifExistSelectedElement || selectedType === 'shape' || selectedType === 'graphFrame_Tbl'
    );

    /**
     * 点击的元素为shape或者为table
     * @param ifExistSelectedElement
     * @param selectedType
     * @param e
     * @returns {*|boolean}
     */
    private mouseDownShowConTextMenu = (ifExistSelectedElement: boolean, selectedType: string, e: MouseEvent) => (
        this.selectIsShapeOrTable(
            ifExistSelectedElement,
            selectedType,
        ) && e.button === MOUSE_EVENT_KEY.RIGHT);

    /**
     * 选中了一张图片，点击到另一张图片
     * @param mouseDownIsImage
     * @param popupMenuNotExist
     * @param sameContainer
     */
    private mouseDownOnOtherImage = (mouseDownIsImage: boolean, popupMenuNotExist: boolean, sameContainer: boolean) => (
        mouseDownIsImage && !popupMenuNotExist && !sameContainer
    );

    /**
     * 点击image是否出现menu
     * @param popupMenuNotExist
     * @param mouseDownIsImage
     * @param sameContainer
     */
    private ifImageShowMenu = (popupMenuNotExist: boolean, mouseDownIsImage: boolean, sameContainer: boolean) => (
        (popupMenuNotExist && mouseDownIsImage)
        || this.mouseDownOnOtherImage(mouseDownIsImage, popupMenuNotExist, sameContainer)
    );

    private imageShowMenu = (e: MouseEvent) => {
        if (!(isIpadApp())) return;
        setTimeout(() => {
            if (this.dropEndAndPrevNoMenu) {
                this.dropEndAndPrevNoMenu = false;
                return;
            }
            const isFirstShowMenu = document.querySelector('#popup-menu-container-id') === null;
            // 全局查找会导致pop存在，点击其他图片的时候无法立即调出菜单
            const popupMenuNotExist = isFirstShowMenu
                ? isFirstShowMenu
                : (document.querySelector('.popup-menu-container-control') as HTMLElement).style?.display === 'none';
            const ifExistSelectedElement = this.getSelectArray() !== null;
            const selectedId = ifExistSelectedElement ? this.getSelectArray()?.[0].id : undefined;
            const sameContainer = selectedId === this.prevMouseDownObjId;
            const selectedType = _get(this.getSelectArray(), '[0].sdkData.type');
            const mouseDownIsImage = selectedType === 'pic';
            this.prevMouseDownObjId = selectedId;
            // 弹窗出现情况
            if (this.mouseDownShowConTextMenu(ifExistSelectedElement, selectedType, e)) {
                // 空白页点击 交互是否要处理？
                const touchX = e.pageX;
                const touchY = e.pageY;
                this.handleContextMenu(touchX, touchY);
                return;
            }
            // image 处理
            if (this.ifImageShowMenu(popupMenuNotExist, mouseDownIsImage, sameContainer)) {
                // 同一个元素连续点击
                if (sameContainer) {
                    this.prevMouseDownObjId = null;
                    return;
                }
                const touchX = e.pageX;
                const touchY = e.pageY;
                this.handleContextMenu(touchX, touchY);
            }
        }, 50);
    };

    private handleContextMenu(touchX: number, touchY: number) {
        if (RegionType.EDITOR === this.getSelectionService().lastMouseDownRegion) return;
        // @ts-ignore
        MobileRightMenuMananger?.showMenu({
            top: touchY,
            left: touchX,
        });
    }

    private handleSysContext() {
        return false;
    }

    private getMobileRightMenuManager() {
        return this.getAppService().viewableServiceLayer?.mobileRightMenuMananger;
    }

    private getSelectionService() {
        return this.getAppService().viewableServiceLayer?.selectionService;
    }

    private getEditingStateManager() {
        return this.getAppService().viewableServiceLayer.editingStateManager;
    }

    private getMenuManager() {
        return this.getAppService().editableServiceLayer?.menuManager;
    }

    private getAppService() {
        return AppServiceProvider.getInstance().getAppServices() as IMobileEditorAppServices;
    }
}

export default MobilePopupWrapper;
